<template>
  <div id="tsinghua">
    <div class="rectangle">
      <router-view :redirectURI="redirectURI" />
    </div>
  </div>
</template>

<script>
  import {
    getTsinghuaURI
  } from '../../util/url'

  export default {
    name: 'tsinghua',
    data() {
      return {
        redirectURI: '',
      }
    },
    computed: {
      currentRouteName() {
        return this.$route.name
      }
    },
    async mounted() {
      const redirectURI = getTsinghuaURI()
      this.redirectURI = redirectURI

      const verifyRet = await this.$api.passport.verifyToken()
      if (verifyRet.status === 1) location.href = redirectURI;
    }
  }
</script>

<style lang="scss" scoped>
  #tsinghua {
    height: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .cover {
    background-size: cover;
    background-position: left center;
  }

  /* 移动设备 */
  @media only screen and (max-width: 720px) {
    .rectangle {
      width: 100%;
      height: 100%;
      border-radius: 0;
      box-shadow: none;
      grid-template-columns: 1fr;
    }

    .semicircle,
    .cover {
      display: none;
    }
  }

  ::v-deep {
    ::-webkit-input-placeholder {
      /* WebKit browsers */
      color: #ffffff;
    }
    ::-moz-placeholder {
      /* Mozilla Firefox 19+ */
      color: #ffffff;
    }
    :-ms-input-placeholder {
      /* Internet Explorer 10+ */
      color: #ffffff;
    }
    input[type="text"],
    input[type="password"] {
      outline: 0;
      border: 0;
      width: 270px;
      height: 40px;
      line-height: 40px;
      background-color: #666666;
      font-size: 15px;
      color: #ffffff;
      padding: 10px;
      box-sizing: border-box;
      border-radius: 4px;
      margin: 7px 0;
    }
    button {
      border: 0;
      outline: 0;
      width: 270px;
      height: 40px;
      line-height: 40px;
      background-color: #5f1d62;
      border-bottom: 5px solid #431447;
      font-size: 15px;
      color: #fff;
      text-align: center;
      border-radius: 4px;
      margin: 5px 0;
      cursor: pointer;
      transition: all .3s ease;

      &:hover {
        background-color: #7f4282;
        border-bottom: 5px solid #69256c;
      }
    }
    .drag_verify {
      border-radius: 4px !important;
      overflow: hidden;
      margin: 5px 0;

      .dv_text {
        color: #ffffff !important;
      }

      .dv_progress_bar {
        transition: background 0.5s ease-in;
      }
    }
    .v-select {
      width: 270px;
      height: 40px;
      margin: 5px 0;
      background: #666666;
      border-radius: 5px;

      .vs__dropdown-toggle {
        height: 40px;
        border: 0;
      }

      .vs__selected,
      .vs__search {
        color: #ffffff;
      }
    }
  }
</style>